import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
import { Checkbox, Form, Input, Space, Typography } from "antd";

const ProbationPolicy = () => {
    const config: MasterConfigs = {
        api: () => '/probation-policies',
        title: 'Probation Policy',
        isActionTab: true,
        modalTitle: () => config.title,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
                align: 'center'
            },
            {
                title: 'Probation Period',
                dataIndex: 'probationPeriod',
                key: 'probationPeriod',
                align: 'center'
            },
            {
                title: 'Period Type',
                dataIndex: 'periodType',
                key: 'periodType',
                align: 'center'
            },
            {
                title: 'Extendable',
                dataIndex: 'extendable',
                key: 'extendable',
                render: (extendable) => extendable + ' Times',
                align: 'center'

            },
            {
                title: 'Evaluation',
                dataIndex: 'evaluate',
                key: 'evaluate',
                render: (evaluate) => evaluate ? 'Yes' : 'No',
                align: 'center'
            },
            {
                title: 'Evaluation Period',
                dataIndex: 'evaluationPeriod',
                key: 'evaluationPeriod',
                render: (evaluationPeriod) => evaluationPeriod ? 'Yes' : 'No',
                align: 'center'
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                span: 8,
            },
            {
                label: 'Probation Period',
                name: 'probationPeriod',
                type: 'number',
            },
            {
                label: 'Months/Weeks/Days',
                name: 'periodType',
                type: 'select',
                children: [
                    { name: 'Months', value: 'Months' },
                    { name: 'Weeks', value: 'Weeks' },
                    { name: 'Days', value: 'Days' },
                ]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 24,
                inputTextAreaProps: { rows: 3 }
            },
            {
                type: 'custom',
                span: 24,
                name: 'extendable',
                formItem: (e) =>
                    <Space direction="horizontal">
                        <Typography.Title level={5}>Maximum number of times probation can be extended</Typography.Title>
                        <Form.Item {...e}>
                            <Input type="number" placeholder="Ex. 2" style={{ width: 100, marginTop: -5 }} />
                        </Form.Item>
                        <Typography.Title level={5}>Times</Typography.Title>
                    </Space>
            },
            {
                type: 'custom',
                span: 24,
                formItem: (e) => <Typography.Title level={5}>Settings</Typography.Title>
            },
            {
                type: 'radio',
                label: 'Do you want to evaluate as part of probation status change ?',
                name: 'evaluate',
                span: 24,
                radioProps: { options: [{ label: 'Yes', value: true }, { label: 'No', value: false }] }
            },
            {
                type: 'checkbox',
                span: 24,
                label: 'End employee probation automatically',
                name: 'evaluationPeriod',
                checkboxProps: { defaultChecked: false }
            }
        ],
    }

    return <MasterComponent config={config} />
}

export default ProbationPolicy;